import capitalize from 'lodash.capitalize';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { Importer, TImporterState } from '@feathr/blackbox';
import type { TStatusTheme } from '@feathr/components';
import { inferPillTheme, StatusPillCell } from '@feathr/components';

interface IProps {
  importer: Importer;
}

export const importerStateThemes: Record<TImporterState, TStatusTheme> = {
  ['draft']: 'neutral',
  ['pending']: 'warning',
  ['complete']: 'success',
  ['failed']: 'error',
};

function ImporterStateChip({ importer }: IProps): JSX.Element {
  const state = importer.get('state');
  return (
    <StatusPillCell
      status={capitalize(state)}
      theme={inferPillTheme(state, importerStateThemes)}
      truncate={false}
    />
  );
}

export default observer(ImporterStateChip);
